var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentDefinition)?_c('popover',{attrs:{"position":_vm.currentDefinitionPosition,"data":_vm.currentDefinition,"definition-path-prefix":_vm.definitionPathPrefix,"blob-path":_vm.currentBlobPath}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }